import initialState from './BrandInitialState';
import reducers from './BrandReducer';

export default {
  initialState,
  reducers,
};
